const timelineContent = {
  change_action: 'Mudou a Ação de ',
  to: 'para',
  change_accountable: 'Mudou o responsável pela Ação de',
  add: 'Adicionou',
  text: 'como o responsável da Ação',
  noAccountable: 'ninguém',
  status: 'Mudou o status de',
  created: 'criou a Ação',
  deadLine: 'Mudou o prazo de',
  change: 'modificou a Ação',
  no_accountable: 'Sem Responsável',
  removedAccountables: 'removeu os responsáveis',
  removedAccountable: 'removeu o responsável',
  addedAccountables: 'adicionou os responsáveis',
  addedAccountable: 'adicionou o responsável',
  andAdded: 'e adicionou',
};

export default timelineContent;
